import qs from 'query-string';
import { get, post, put, del } from '../baseApi';

export const AccountApi = {
    fetch: (query) => get(`/admin/accounts?${qs.stringify(query)}`),
    fetchById: (id) => get(`/admin/accounts/${id}`),
    create: (data) => post('/admin/accounts', data),
    update: (id, data) => put(`/admin/accounts/${id}`, data),
    delete: (id) => del(`/admin/accounts/${id}`),
};
